import { SistemaDesktop } from './sistema-desktop.enum'
import { VersaoDesktopJson } from './versao-deskptop-json.interface'

export class VersaoDesktop {
    sistema: SistemaDesktop
    numero: number[]

    constructor(obj: VersaoDesktopJson) {
        this.sistema = obj.Sistema
        this.numero = obj.Versao.split('.').map(n => Number.parseInt(n))
    }

    isIgualOuSuperior(numero: number[] | string) {
        if (typeof numero === 'string') {
            numero = numero.split('.').map(n => Number.parseInt(n))
        }

        for (let i = 0; i < this.numero.length; i++) {
            const n = this.numero[i]
            const testN = numero[i]

            if (n > testN) {
                return true
            } else if (n === testN) {
                if (i === this.numero.length - 1) {
                    return true
                }
            } else {
                break
            }
        }

        return false
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/controle-versao/versao-desktop.ts